import { clients } from '@/lib/https';

const IAM_API_BASE_URL = import.meta.env.VITE_IAM_API_BASE_URL?.replace(/\/$/, '') ?? '';

export const getIamApiUrl = (path: string): string => {
  if (!IAM_API_BASE_URL) {
    throw new Error('VITE_IAM_API_BASE_URL is not configured');
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (IAM_API_BASE_URL.startsWith('http')) {
    return `${IAM_API_BASE_URL}${normalizedPath}`;
  }

  const basePath = IAM_API_BASE_URL.startsWith('/')
    ? IAM_API_BASE_URL
    : `/${IAM_API_BASE_URL}`;

  return `${window.location.origin}${basePath}${normalizedPath}`;
};

export const iamApiGet = async <T>(path: string): Promise<T> => {
  return clients.get<T>(getIamApiUrl(path));
};

export const iamApiPost = async <T>(path: string, body: unknown): Promise<T> => {
  return clients.post<T>(getIamApiUrl(path), JSON.stringify(body));
};
